// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { action, observable } from 'mobx'
import { isMobile } from 'react-device-detect'
import { IStores } from '.'
import { sendBookingAnalyticEvent } from '../services/analyticsService'
import { getFromApi } from '../services/apiService'

const build_PRODUCTS_URL = () => '/v5/reserve/products'

export enum ScheduleSelectionType {
  RANGE = 'range',
  START_AND_DURATION = 'start_and_duration',
  START = 'start'
}

export interface IProduct {
  reference: string;
  durationUnit: number;
  scheduleUnit: number;
  paymentMode: 'subscription' | 'cash_payment' | 'none';
  name: string,
  description: string,
  descriptionReference?:string | null,
  marketingLabel: string,
  scheduleSelectionType: ScheduleSelectionType
  minimumDurationUnit? :number| null
  maximumDurationUnit?:number | null
  minimumLeadTimeInScheduleUnit?: number | null
  maximumLeadTimeInScheduleUnit?: number | null
  datesLabel?: string | null// TODO add in API
  returnTime?: string | null// TODO add in API
  pickupTime?: string | null // TODO add in API
  requireTermsAndConditionsValidation?: boolean | null // TODO add in API
  isTermsListChecked?: boolean
}

class ProductsStore {
  store: IStores

  @observable loading = false

  @observable products: IProduct[] = []
  @observable selectedProduct: IProduct | null = null

  @observable isTermsListChecked = false

  constructor(store: IStores) {
    this.store = store
  }

  @action setIsTermsListChecked = (val: boolean) => {
    this.isTermsListChecked = val
  }

  @action initialise = async (): Promise<void> => {
    this.loading = true
    sendBookingAnalyticEvent('book_step_1')
    const response = await getFromApi(build_PRODUCTS_URL())

    this.products = response && response.status === 200 ? response.data?.products || [] : []

    if (this.products.length === 1 || isMobile) {
      this.selectedProduct = this.products[0]
    }

    this.loading = false
  }

  @action selectProduct = async (
    product: IProduct | null,
    inverseSelection = false
  ) => {
    this.loading = true

    if (this.selectedProduct === null) {
      this.selectedProduct = product
    } else if (inverseSelection && product?.reference === this.selectedProduct?.reference) {
      this.selectedProduct = null
    } else {
      this.selectedProduct = product

      if (this.store.locationsStore.selectedLocation && product && !this.store.locationsStore.selectedLocation.productReferences.includes(product.reference)) {
        this.store.locationsStore.selectLocation(null)
        this.store.locationsStore.selectCity(null)
      }
    }
    sendBookingAnalyticEvent('book_step_1_change_type')
    this.loading = false
  }

  @action selectProductByReference = async (
    productReference: string,
    inverseSelection = false,
    InForce = false
  ) => {
    const product = this.store.productsStore.products.find(
      p => p.reference === productReference
    ) || null

    if (product && InForce === true) {
      this.products = [product]
    }
    await this.selectProduct(
      product,
      inverseSelection
    )
  }
}

export default ProductsStore
